import FormalPink from '../LoaderCard/lotties-for-loaders/Formal-shirt - pink.json';
import PurseViolet from '../LoaderCard/lotties-for-loaders/Purse - violet.json';
import SkirtPink from '../LoaderCard/lotties-for-loaders/Skirt - pink.json';
import HandBagViolet from '../LoaderCard/lotties-for-loaders/Hand-bag - violet.json';
import WomenDressViolet from '../LoaderCard/lotties-for-loaders/Women-dress - violet.json';
import Pantsviolet from '../LoaderCard/lotties-for-loaders/Pants - violet.json';
import WomenDressPink from '../LoaderCard/lotties-for-loaders/Women-dress - pink.json';
import ShortsPink from '../LoaderCard/lotties-for-loaders/Shorts - pink.json';
import WatchPink from '../LoaderCard/lotties-for-loaders/Wrist-watch - pink.json';
import WristVoilet from '../LoaderCard/lotties-for-loaders/Wrist-watch - violet.json';
import HighHeelPink from '../LoaderCard/lotties-for-loaders/High-heeled-sandals - pink.json';
import HighHeelBootViolet from '../LoaderCard/lotties-for-loaders/High-heeled-boots - violet.json';
import HoodiePink from '../LoaderCard/lotties-for-loaders/Hoodie - pink.json';
import GemPink from '../LoaderCard/lotties-for-loaders/Gem - pink.json';
import SneakersPink from '../LoaderCard/lotties-for-loaders/Sneakers - pink.json';
import GemViolet from '../LoaderCard/lotties-for-loaders/Gem - violet.json';
import FullShirtPink from '../LoaderCard/lotties-for-loaders/Women-full-sleeved-shirt - pink.json';
import SneakersViolet from '../LoaderCard/lotties-for-loaders/Sneakers - violet.json';
import { FormalShirt, Purse, Skirt, HandBag, HighHeeledSandal, WomenDress, Pants, Shorts, WristWatch, HighHeeledBoot, Hoodie, Gem, Sneakers, FormalWomen } from '../../../../FlyfishComponents/flyfishIcons/icons';
export const getCssVariable = (variableName) => {
    return getComputedStyle(document.documentElement)
        .getPropertyValue(variableName)
        .trim();
}
const ffPrimaryOriginal = getCssVariable('--ffPrimaryOriginal');
const ffPrimary300 = getCssVariable('--ffPrimary300');
const ffPrimary50 = getCssVariable('--ffPrimary50');
const ffSecondary300 = getCssVariable('--ffSecondary300');
const ffSecondary50 = getCssVariable('--ffSecondary50');

export const Fashionlotties = /*This contains all the lottie paths*/ {
    lottieSequence1: {
        colorSequence: {
            colorPattern0:
                //single color
                [ffPrimary300],
            colorPattern1:
                //2 color, middle stands out
                [ffPrimary300, ffSecondary300],
            colorPattern2:
                //2 color, diagonals
                [ffSecondary300, ffSecondary300, ffPrimary300, ffPrimary300],
            colorPattern3:
                //custom
                ['#ff9e8e', '#c6c400', '#71d86a', '#00d7d8', '#87c1ff', '#fa8df9'],
        },
        lottie1: {
            url:
                FormalPink,
            svg: FormalShirt


        },
        lottie2: {
            url: PurseViolet,
            svg: Purse

        },
        lottie3: {
            url:
                SkirtPink,
            svg: Skirt,

        },
        lottie4: {
            url:
                HandBagViolet,
            svg: HandBag

        },
        lottie5: {
            url:
                WomenDressViolet,
            svg: WomenDress

        }
    },
    lottieSequence2: {
        colorSequence: {
            colorPattern0:
                //single color
                [ffPrimary300],
            colorPattern1:
                //2 color, middle stands out
                [ffPrimary300, ffSecondary300],
            colorPattern2:
                //2 color, diagonals
                [ffPrimary300, ffPrimary300, ffSecondary300, ffSecondary300],
            colorPattern3:
                //custom
                ['#c6c400', '#71d86a', '#00d7d8', '#87c1ff', '#fa8df9', '#ff9e8e'],
        },
        lottie1: {
            url:
                Pantsviolet,
            svg: Pants

        },
        lottie2: {
            url:
                WomenDressPink,
            svg: WomenDress

        },
        lottie3: {
            url:
                HandBagViolet,
            svg: HandBag

        },
        lottie4: {
            url:
                ShortsPink,
            svg: Shorts

        },
        lottie5: {
            url:
                WatchPink,
            svg: WristWatch

        }
    },
    lottieSequence3: {
        colorSequence: {
            colorPattern0:
                //single color
                [ffPrimary300],
            colorPattern1:
                //2 color, middle stands out
                [ffPrimary300, ffSecondary300],
            colorPattern2:
                //2 color, diagonals
                [ffPrimary300, ffPrimary300, ffSecondary300, ffSecondary300],
            colorPattern3:
                //custom
                ['#c6c400', '#71d86a', '#00d7d8', '#87c1ff', '#fa8df9', '#ff9e8e'],
        },
        lottie1: {
            url:
                WristVoilet,
            svg: WristWatch

        },
        lottie2: {
            url:
                HighHeelPink,
            svg: HighHeeledSandal

        },
        lottie3: {
            url:
                HighHeelBootViolet,
            svg: HighHeeledBoot

        },
        lottie4: {
            url:
                HoodiePink,
            svg: Hoodie

        },
        lottie5: {
            url:
                GemPink,
            svg: Gem

        }
    },
    lottieSequence4: {
        colorSequence: {
            colorPattern0:
                //single color
                [ffPrimary300],
            colorPattern1:
                //2 color, middle stands out
                [ffPrimary300, ffSecondary300],
            colorPattern2:
                //2 color, diagonals
                [ffSecondary300, ffSecondary300, ffPrimary300, ffPrimary300],
            colorPattern3:
                //custom
                ['#ff9e8e', '#c6c400', '#71d86a', '#00d7d8', '#87c1ff', '#fa8df9'],
        },
        lottie1: {
            url:
                SneakersPink,
            svg: Sneakers

        },
        lottie2: {
            url:
                GemViolet,
            svg: Gem

        },
        lottie3: {
            url:
                FullShirtPink,
            svg: FormalWomen

        },
        lottie4: {
            url:
                SneakersViolet,
            svg: Sneakers

        },
        lottie5: {
            url:
                HighHeelBootViolet,
            svg: HighHeeledBoot

        }
    }
};
export const Footwearlotties = /*This contains all the lottie paths*/ {
    lottieSequence1: {
        colorSequence: {
            colorPattern0:
                //single color
                [ffPrimary300],
            colorPattern1:
                //2 color, middle stands out
                [ffPrimary300, ffSecondary300],
            colorPattern2:
                //2 color, diagonals
                [ffSecondary300, ffSecondary300, ffPrimary300, ffPrimary300],
            colorPattern3:
                //custom
                ['#ff9e8e', '#c6c400', '#71d86a', '#00d7d8', '#87c1ff', '#fa8df9'],
        },

        lottie1: {
            url:
                SneakersPink,
            svg: Sneakers
        },
        lottie2: {
            url:
                HighHeelBootViolet,
            svg: HighHeeledBoot

        },
        lottie3: {
            url:
                HandBagViolet,
            svg: HandBag
        },
        lottie4: {
            url:
                HighHeelPink,
            svg: HighHeeledSandal
        },
        // lottie3: {
        //     url:
        //         HandBagViolet,
        //     svg: HandBag
        // },
        // lottie4: {
        //     url:
        //         SneakersPink,
        //     svg: Sneakers
        // },

    },
    lottieSequence2: {
        colorSequence: {
            colorPattern0:
                //single color
                [ffPrimary300],
            colorPattern1:
                //2 color, middle stands out
                [ffPrimary300, ffSecondary300],
            colorPattern2:
                //2 color, diagonals
                [ffPrimary300, ffPrimary300, ffSecondary300, ffSecondary300],
            colorPattern3:
                //custom
                ['#c6c400', '#71d86a', '#00d7d8', '#87c1ff', '#fa8df9', '#ff9e8e'],
        },

        lottie1: {
            url:
                HandBagViolet,
            svg: HandBag
        },
        lottie2: {
            url:
                SneakersPink,
            svg: Sneakers
        },
        lottie3: {
            url:
                HighHeelBootViolet,
            svg: HighHeeledBoot

        },
        lottie4: {
            url:
                HandBagViolet,
            svg: HandBag
        },
        // lottie2: {
        //     url:
        //         HighHeelPink,
        //     svg: HighHeeledSandal
        // },
        // lottie3: {
        //     url:
        //         HandBagViolet,
        //     svg: HandBag
        // },
        // lottie4: {
        //     url:
        //         SneakersPink,
        //     svg: Sneakers
        // },

    },
    lottieSequence3: {
        colorSequence: {
            colorPattern0:
                //single color
                [ffPrimary300],
            colorPattern1:
                //2 color, middle stands out
                [ffPrimary300, ffSecondary300],
            colorPattern2:
                //2 color, diagonals
                [ffPrimary300, ffPrimary300, ffSecondary300, ffSecondary300],
            colorPattern3:
                //custom
                ['#c6c400', '#71d86a', '#00d7d8', '#87c1ff', '#fa8df9', '#ff9e8e'],
        },

        // lottie1: {
        //     url:
        //         SneakersPink,
        //     svg: Sneakers
        // },
        lottie1: {
            url:
                HighHeelBootViolet,
            svg: HighHeeledBoot

        },
        lottie2: {
            url:
                HandBagViolet,
            svg: HandBag
        },
        lottie3: {
            url:
                HighHeelBootViolet,
            svg: HighHeeledBoot

        },
        lottie4: {
            url:
                HighHeelBootViolet,
            svg: HighHeeledBoot

        },
        // lottie3: {
        //     url:
        //         HighHeelPink,
        //     svg: HighHeeledSandal
        // },
        // lottie4: {
        //     url:
        //         SneakersPink,
        //     svg: Sneakers
        // },

    },
    lottieSequence4: {
        colorSequence: {
            colorPattern0:
                //single color
                [ffPrimary300],
            colorPattern1:
                //2 color, middle stands out
                [ffPrimary300, ffSecondary300],
            colorPattern2:
                //2 color, diagonals
                [ffSecondary300, ffSecondary300, ffPrimary300, ffPrimary300],
            colorPattern3:
                //custom
                ['#ff9e8e', '#c6c400', '#71d86a', '#00d7d8', '#87c1ff', '#fa8df9'],
        },

        lottie2: {
            url:
                HighHeelBootViolet,
            svg: HighHeeledBoot

        },
        lottie1: {
            url:
                HighHeelPink,
            svg: HighHeeledSandal
        },
      
        lottie3: {
            url:
                SneakersPink,
            svg: Sneakers
        },
        lottie4: {
            url:
                HandBagViolet,
            svg: HandBag
        },
   

        // lottie1: {
        //     url:
        //         SneakersPink,
        //     svg: Sneakers
        // },
        // lottie2: {
        //     url:
        //         HandBagViolet,
        //     svg: HandBag
        // },
        // lottie3: {
        //     url:
        //         HighHeelPink,
        //     svg: HighHeeledSandal
        // },
        // lottie4: {
        //     url:
        //         SneakersPink,
        //     svg: Sneakers
        // },

    }
};


export const loadingEcomMessages = [
    "Finding the best products for you...",
    "Combing through the catalog...",
    "Analyzing fashion trends...",
    "Gathering your fashion picks...",
    "Spotting standout styles...",
    "Discovering chic choices..."
]
export const loadingFootwearMessages = [
    "Crocs are for comfort, not compliments!",
    "Shoes speak louder than words — choose wisely",
    "Socks and sandals — still a hard pass",
    "Flip-flops scream beach, not brunch",
    "Bright shoes = Instant attention magnet",
    "Match your belt to your shoes, not to your mood!",
    "Keep your heels and standards high"
]
export const loadingMessageDurationMin = 2000;
export const loadingMessageDurationMax = 3000;

export const shuffleArrayMessage = (array) => {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
}

export const getRandomTime = (min, max) => {
    return Math.random() * (max - min) + min;
}




export const seededRandom = (seed) => {
    let x = Math.sin(seed) * 10000;
    return x - Math.floor(x);
}

export const shuffleArray = (array, seed) => {
    let randomSeed = seed; // Initialize with the seed
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(seededRandom(randomSeed) * (i + 1)); // Use seeded random
        [array[i], array[j]] = [array[j], array[i]]; // Swap elements
        randomSeed++; // Increment the seed to ensure different random values
    }
    return array;
}